import React from "react";

export default function Watermark() {
  return (
    <img
      src="/reportmaster-watermark.png"
      alt="ReportMaster Logo"
      className="w-32 md:w-40 mb-4"
      style={{ userSelect: "none" }}
    />
  );
}
